import { expectsBankTransfer } from './outcome';

export type ConfirmationType = 'regular' | 'auto' | 'omitted' | 'pending';

export const OMITTED_STATUS = 'omitted';

interface ConfirmationParams {
  market: string;
  automaticApproval: boolean;
  status?: string;
  paymentMethod?: string;
}

export const resolveConfirmationType = ({
  market,
  automaticApproval,
  status,
  paymentMethod,
}: ConfirmationParams): ConfirmationType => {
  if (!automaticApproval || market === 'BR') return 'regular';
  if (status === OMITTED_STATUS) return 'omitted';
  if (expectsBankTransfer(status, paymentMethod)) return 'pending';
  return 'auto';
};
